import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentSchema: 'individual1',
};

const schemaSlice = createSlice({
  name: 'schema',
  initialState,
  reducers: {
    setCurrentSchema(state, action) {
      state.currentSchema = action.payload;
    },
  },
});

export const { setCurrentSchema } = schemaSlice.actions;

export default schemaSlice.reducer;

// const currentSchema = useSelector(state => state.schema.currentSchema)
// dispatch(setCurrentSchema({ 'individual2' })
